import { map } from 'rxjs/operators';

/**
 * Created by dinesh on 13/6/17.
 */
import { Component, OnInit } from '@angular/core';
import { AngularTokenService } from '@lakshvairav/angular-token';
import { Router } from '@angular/router';

import { AuthorizationService } from '../../shared/authorization.service';
import { KeyValue } from '../../shared/key-value';

@Component({
  selector: 'sign-in',
  templateUrl: 'sign-in.component.html',
  styleUrls: ['sign-in.component.css']
})
export class SignInComponent implements OnInit {
  email: string;
  password: string;
  terms_chkbox: boolean = false;
  public errorMsg = '';
  demoLink: string;
  disable_terms = false;
  disable_login = false;
  //loader:boolean=false;
  res = '';
  showform: boolean = false;
  login_notification = {
    is_notification_active: false,
    start_date_notification: '',
    start_time_notification: '',
    end_date_notification: '',
    end_time_notification: '',
    message_text: ''
  };
  notification_id = '';
  resetPasswordSuccessMessage: string;
  currentYearCopyRight: number = new Date().getFullYear();
  constructor(private router: Router, private _tokenService: AngularTokenService,
    public authService: AuthorizationService) {
    if (localStorage.getItem('uid') != undefined) {
      this._tokenService.validateToken().subscribe(
        res => {
          console.log('....' + JSON.stringify(res));
          localStorage.setItem('currentUserData', JSON.stringify(res));
          this.showform = false;
          authService.grantAccess();
        },
        error => {
          console.log(error);
          this.showform = true;
        }
      );
    } else {
      this.showform = true;
    }
    this.errorMsg = this.authService.error_msg_agreement_rejected  //KeyValue.licence_rejected_msg;
    this.demoLink = KeyValue.demoLink; // To get the watch demo link
  }

  deneyAccess(error) {
    console.log(error);
    if (error.error && error.error.errors) {
      this.errorMsg = error.error.errors;
    } else {
      this.errorMsg = 'An error occurred.';
    }
  }
  
  ngOnInit() {
    // setTimeout(function(){
    //   init_input_check();
    // }, 1000);

    // const backdrop = document.getElementsByClassName('modal-backdrop')
    // if (backdrop.length !== 0 ) {
    //   const child = backdrop[0];
    //   child.parentNode.removeChild(child);
    // }
    const savedNotificationId = localStorage.getItem('notification_id') || '1';
    this.getNotificationData(savedNotificationId);
    // Get reset password success message from localStorage
    this.resetPasswordSuccessMessage = localStorage.getItem('resetPasswordSuccessMessage');
    if (this.resetPasswordSuccessMessage) {
      localStorage.removeItem('resetPasswordSuccessMessage');
      setTimeout(() => {
        this.resetPasswordSuccessMessage = '';
      }, 10000);
    }
  }

  onEmailBlur() {
    
    this.terms_chkbox = false;
    this.disable_terms = false;
    if (this.email) {
      // console.log('email changes ' + this.email)
      this.disableLogin()
      KeyValue.animStatus_update('start');
      this.authService.get(`${KeyValue.api_fetch_agreement}`,{params: {email: this.email}})
        .pipe(map(res => res)).subscribe(
          data => {
            // disable enable terms checkbox
            if(data.agreement_accepted==true){
              this.terms_chkbox = true
              this.disable_terms = true
            } else {
              this.terms_chkbox = false
              this.disable_terms = false
            }
            this.enableLogin();
            KeyValue.animStatus_update('end');
          },
          error => {
            KeyValue.animStatus_update('end');
            this.disable_login = false;
            console.log('in... api failure' + error)
          }
        );
    }
  }

  submit_login() {
    this.authService.error_msg_agreement_rejected = '';
    this.disableLogin();

    this._tokenService.signIn({
      login: this.email,
      password: this.password
    }).subscribe(
      data => {
        this.authService.checkIfLoggedoutInDupTab();
        this.authService.grantAccess();
        if (this.authService.logoutTimerStarted === false) {
          this.authService.logoutTimerStarted = true;
          this.authService.startTimer(); // Use default 5-hour timeout
        }
        // Set currentUserData in localStorage after successful sign-in
        localStorage.setItem('currentUserData', JSON.stringify(data));
      },
      error => {
        this.enableLogin();
        this.deneyAccess(error);
      }
    );
  }

  disableLogin(): void{
    this.disable_login = true;
  }

  enableLogin(): void {
    setTimeout(()=>{
      this.disable_login = false;
    },1000);
  }

  submit(): void {
    console.log('submit 1......................');
    console.log(this.terms_chkbox);
    console.log('submit 2......................');

    this.errorMsg = '';
    if (this.email != '' && this.password != '' && this.email != undefined && this.password != undefined) {
      if (this.terms_chkbox != false) {
        //this.loader = true;
        KeyValue.animStatus_update('start');
        // this.disable_login = true;
        this.disableLogin();
        const signin = this;
        setTimeout(function () {
          signin.submit_login();
          // signin.loader = false;
          KeyValue.animStatus_update('end');

        }, 500);
      }
      else {
        this.enableLogin();
        this.errorMsg = 'Please accept the Terms and Conditions.';
      }
    }
    else {
      this.enableLogin();
      this.errorMsg = 'Please input your Email and Password to proceed.';
    }
  }

  forgotpassword(): void {
    //event.preventDefault();
    console.log('inside forgotpassword course');
    this.router.navigate(['/forgot-password']);
  }

  revealPassword(id) {
    const element = (document.getElementById(id) as HTMLInputElement);
    if (element.type === 'password') {
      element.type = 'tpasswordext';
      (document.getElementsByClassName('eye_img')[0] as HTMLInputElement).src = 'assets/images/eye.svg';
    } else {
      element.type = 'password';
      (document.getElementsByClassName('eye_img')[0] as HTMLInputElement).src = 'assets/images/eye_password.svg';
    }
  }

  getNotificationData(notification_id) {
    this.authService.get(`${KeyValue.api_update_login_notification}/${notification_id}`)
      .pipe(map(res => res)).subscribe(
        data => {
          console.log(data)
          this.setNotificationData(data);
        },
        error => {
          console.log('in... api failure' + error)
        }
      );
  }

  setNotificationData(data) {
    this.login_notification.is_notification_active = data.active;
    this.login_notification.start_date_notification = new Date(data.start).toLocaleDateString('en-US', { timeZone: 'UTC', month: '2-digit', day: '2-digit', year: 'numeric' });
    this.login_notification.start_time_notification = this.formatTimeTo12Hour(data.start);
    this.login_notification.end_date_notification = new Date(data.end).toLocaleDateString('en-US', { timeZone: 'UTC', month: '2-digit', day: '2-digit', year: 'numeric' });
    this.login_notification.end_time_notification = this.formatTimeTo12Hour(data.end);
    this.login_notification.message_text = data.message || '';
  }

  // Function to convert time to 12-hour format with AM/PM
  formatTimeTo12Hour(dateString: string): string {
    const date = new Date(dateString);
    const hoursUTC = date.getUTCHours();
    const minutesUTC = date.getUTCMinutes();
    const ampm = hoursUTC >= 12 ? 'PM' : 'AM';
    const hours12 = hoursUTC % 12 || 12;
    const minutesPadded = minutesUTC < 10 ? '0' + minutesUTC : minutesUTC;
    return `${hours12}:${minutesPadded} ${ampm}`;
  }

  showNotification() {
    const currentDateTime = new Date().getTime();
    const startDateTime = new Date(`${this.login_notification.start_date_notification} ${this.login_notification.start_time_notification}`).getTime();
    const endDateTime = new Date(`${this.login_notification.end_date_notification} ${this.login_notification.end_time_notification}`).getTime();
    if (this.login_notification.is_notification_active && startDateTime <= currentDateTime && endDateTime >= currentDateTime) {
      return this.login_notification.message_text + ' from ' + this.login_notification.start_date_notification + ' ' + this.login_notification.start_time_notification + ' to ' + this.login_notification.end_date_notification + ' ' + this.login_notification.end_time_notification;
    } else {
      return '';
    }
  }

}
